module.exports = __webpack_public_path__ + "static/media/Flaticon.b9b714e8.eot";